import * as React from 'react';
import type { ProjectId, AssetId } from 'owa-timestream-types';
import { getLastKnownBounds, getAsset } from 'owa-timestream-store';
import { observer } from 'mobx-react-lite';
import { getCanvasView } from 'owa-timestream-asset-sdk';

export default observer(function TimeStreamMiniMapAsset({
    projectId,
    assetId,
}: {
    projectId: ProjectId;
    assetId: AssetId;
}) {
    const { type } = getAsset(projectId, assetId);
    if (!getCanvasView(type)) {
        return null;
    }

    const bounds = getLastKnownBounds(projectId, assetId);
    if (!bounds) {
        return null;
    }

    const { x, y, width, height } = bounds;
    return <rect x={x} y={y} width={width || 10} height={height || 10} rx="10" ry="10" />;
});
